import {
    OrderDocumentStatus,
    TlzEnvironment,
    _getOrderStatusUrl,
} from '../constants';

export const getOrderStatus = async (
    orderId: string,
    env: TlzEnvironment,
    isBffEnabled: boolean,
): Promise<OrderDocumentStatus> => {
    const response = await fetch(
        _getOrderStatusUrl(orderId, env, isBffEnabled),
        {
            method: 'GET',
            credentials: 'include',
        },
    );

    const body = await response.json();

    if (body.error) {
        throw new Error(
            `CheckoutStatusAPI returned a body describing an error: ${body.error} (full body: ${body})`,
        );
    }

    return body.status;
};
